export const IDS = {

    pnpSettingsDocumentCategoryGrid: 'pnpSettingsDocumentCategoryGrid',
   
    // settings categories states :
    app_policies_settings_categories_add: 'app.policies.settings.categories.add',
    app_policies_settings_categories_add_details: 'app.policies.settings.categories.add.details',
    app_policies_settings_categories_manage: 'app.policies.settings.categories.manage',
    app_policies_settings_categories_manage_details: 'app.policies.settings.categories.manage.details',
    app_policies_settings_categories_manage_listing: 'app.policies.settings.categories.manage.listing',
};